<!--
    描述：考核规则
    时间：2021-03-04
    Created by 王帅
    updated by 钱磊 2022-5-18 11:05:04
-->
<template>
    <w-split class="h100" v-model="splitValue" v-if="!routeQuery.type">
        <!-- 左侧考核双方 -->
        <div class="w-page-main" slot="left">
            <div class="w-page-header">
                <div class="left-text overflow-hidden">
                    <span>考核双方</span>
                </div>
                <div class="btnGroups ml10">
                    <el-button type="success" size="mini" @click="handleRolesClick('add')"
                        >添加</el-button
                    >
                </div>
            </div>
            <div class="w-page-container pdb10">
                <div class="h100">
                    <vxe-table
                        ref="leftTable"
                        :data="tableObj.tableData"
                        :loading="tableObj.loading"
                        :border="tableObj.border"
                        :resizable="tableObj.resizable"
                        :size="tableObj.size"
                        :height="tableObj.height"
                        highlight-current-row
                        highlight-hover-row
                        show-overflow="tooltip"
                        auto-resize
                        show-header-overflow="tooltip"
                        @current-change="onLeftRowClick"
                    >
                        <vxe-table-column
                            v-for="(item, index) in roleColumns"
                            :key="item.prop"
                            :field="item.prop"
                            :title="item.title"
                            :min-width="item.minWidth"
                            :width="item.width"
                            :sortable="item.sortable"
                            :align="item.align"
                            :header-align="item.headerAlign"
                        ></vxe-table-column>
                        <vxe-table-column title="操作" min-width="160" align="center">
                            <template v-slot="{ row }">
                                <el-button
                                    type="success"
                                    size="small"
                                    round
                                    plain
                                    class="table-btn"
                                    @click.stop="handleRolesClick('edit', row)"
                                >
                                    <svg-icon icon-class="form-edit"></svg-icon> 编辑
                                </el-button>
                                <el-button
                                    type="danger"
                                    size="small"
                                    round
                                    plain
                                    class="table-btn"
                                    icon="el-icon-delete"
                                    @click.stop="handleRolesClick('delete', row)"
                                    >删除
                                </el-button>
                            </template>
                        </vxe-table-column>
                    </vxe-table>
                </div>
            </div>
        </div>

        <!-- 右侧规则 -->
        <div class="operation-layout" slot="right">
            <div class="filter-box" v-show="showFilter"></div>
            <div class="operation-main">
                <!-- 头部按钮 -->
                <div class="operation-header">
                    <div class="title">
                        合计版本：<span class="blue">{{ searchObj.totalResult }}</span> 条
                    </div>
                    <div class="btnGroups">
                        <el-button
                            class="btn-success"
                            size="small"
                            @click="handleTools('add')"
                            >新增</el-button
                        >
                        <el-button
                            type="primary"
                            class="ml10"
                            size="small"
                            disabled
                            @click="showFilter = !showFilter"
                        >
                            筛选
                            <i v-if="showFilter" class="el-icon-caret-bottom ml5"></i>
                            <i v-else class="el-icon-caret-top ml5"></i>
                        </el-button>
                        <el-button
                            size="small"
                            class="btn-blue"
                            icon="el-icon-refresh"
                            type="primary"
                            @click="doRefresh"
                        ></el-button>
                    </div>
                </div>

                <!-- 表格 -->
                <div class="operation-container w-table-layout w-table-page">
                    <div class="w-table-content">
                        <vxe-table
                            ref="rightTable"
                            :data="rightTableObj.tableData"
                            :loading="rightTableObj.loading"
                            :border="rightTableObj.border"
                            :resizable="rightTableObj.resizable"
                            :size="rightTableObj.size"
                            :height="rightTableObj.height"
                            highlight-current-row
                            highlight-hover-row
                            auto-resize
                            show-overflow="tooltip"
                            show-header-overflow="tooltip"
                        >
                            <vxe-table-column
                                type="seq"
                                title="序号"
                                width="60"
                                align="center"
                            ></vxe-table-column>
                            <vxe-table-column
                                v-for="(item, index) in activeColumns"
                                :key="item.prop"
                                :field="item.prop"
                                :title="item.title"
                                :min-width="item.minWidth"
                                :width="item.width"
                                :align="item.align"
                                :header-align="item.headerAlign"
                            >
                                <template v-slot="{ row }">
                                    <span v-if="item.needRender">{{
                                        item.function(row[item.prop])
                                    }}</span>

                                    <div
                                        slot="reference"
                                        class="detail-name"
                                        v-else-if="item.prop === 'value3'"
                                        @click="handleTools('view', row)"
                                    >
                                        明细
                                    </div>
                                    <!-- <el-popover v-else-if="item.prop === 'value3'" trigger="hover" placement="top">
                                        <p>姓名: {{ row.name }}</p>
                                        <p>住址: {{ row.address }}</p>
                                        <div slot="reference" class="name-wrapper" @click="handleTools('view', row)">
                                            明细
                                        </div>
                                    </el-popover> -->
                                    <span v-else>{{ row[item.prop] }}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column
                                field="status"
                                title="状态"
                                width="120"
                                align="center"
                            >
                                <template v-slot="{ row }">
                                    <vxe-switch
                                        v-model="row.status"
                                        open-label="启用"
                                        :open-value="1"
                                        close-label="关闭"
                                        :close-value="0"
                                        @change="changeStatus(row)"
                                    ></vxe-switch>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column title="操作" min-width="160" align="center">
                                <template v-slot="{ row }">
                                    <el-button
                                        type="success"
                                        size="small"
                                        round
                                        plain
                                        class="table-btn"
                                        :disabled="row.status === 1"
                                        @click="handleTools('edit', row)"
                                    >
                                        <svg-icon icon-class="form-edit"></svg-icon> 编辑
                                    </el-button>
                                    <el-button
                                        type="danger"
                                        size="small"
                                        round
                                        plain
                                        class="table-btn"
                                        icon="el-icon-delete"
                                        :disabled="row.status === 1"
                                        @click="handleTools('delete', row)"
                                        >删除
                                    </el-button>
                                </template>
                            </vxe-table-column>
                        </vxe-table>
                    </div>
                    <div class="w-table-footer">
                        <vxe-pager
                            size="mini"
                            :current-page="searchObj.currentPage"
                            :page-size="searchObj.pageSize"
                            :total="searchObj.totalResult"
                            class="text-center"
                            :page-sizes="[
                                10,
                                20,
                                50,
                                100,
                                { label: '全部数据', value: -1 },
                            ]"
                            :layouts="[
                                'Total',
                                'Sizes',
                                'PrevPage',
                                'JumpNumber',
                                'NextPage',
                                'FullJump',
                            ]"
                            @page-change="handlePageChange"
                        >
                        </vxe-pager>
                    </div>
                </div>
            </div>

            <!-- 弹窗 -->
            <el-dialog
                :visible.sync="dialogObj.visible"
                :width="dialogObj.width"
                :title="dialogObj.title"
                :fullscreen="dialogObj.fullscreen"
                center
                :before-close="onBeforeClose"
                :close-on-click-modal="false"
            >
                <!-- 左侧新增、编辑考核双方 -->
                <el-form
                    ref="roleForm"
                    :model="formData"
                    :rules="rules"
                    size="small"
                    label-width="140px"
                    v-if="dialogObj.module === 'role'"
                >
                    <el-form-item label="考核人角色" prop="judgeRole">
                        <el-select
                            v-model="formData.judgeRole"
                            placeholder="请选择考核人角色"
                            clearable
                        >
                            <el-option
                                v-for="(item, index) in pjrjs"
                                :key="index"
                                :label="item.sname"
                                :value="item.value"
                                :disabled="
                                    formData.beJudgeRole === item.value || item.disabled
                                "
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="被考核人角色" prop="beJudgeRole">
                        <el-select
                            v-model="formData.beJudgeRole"
                            placeholder="请选择被考核人角色"
                            clearable
                        >
                            <el-option
                                v-for="(item, index) in pjrjs"
                                :key="'被考核人' + index"
                                :label="item.sname"
                                :value="item.value"
                                :disabled="
                                    formData.judgeRole === item.value || item.disabled
                                "
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="考核对象" prop="markObj">
                        <el-select
                            v-model="formData.markObj"
                            placeholder="请选择考核对象"
                            clearable
                        >
                            <el-option
                                v-for="(item, index) in pjdx"
                                :key="index"
                                :label="item.sname"
                                :value="item.value"
                                :disabled="item.disabled"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="适用业务" prop="applyBus">
                        <el-select
                            v-model="formData.applyBus"
                            placeholder="请选择适用业务"
                            clearable
                        >
                            <el-option
                                v-for="(item, index) in yyyw"
                                :key="index"
                                :label="item.sname"
                                :value="item.value"
                                :disabled="item.disabled"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>

                <!-- footer 组件 -->
                <div slot="footer" class="pdb10 text-center">
                    <el-button size="small" class="btn" @click="dialogObj.visible = false"
                        >取 消
                    </el-button>
                    <el-button
                        type="primary"
                        size="small"
                        class="btn btn-blue"
                        @click="doRoleSave"
                        >确 定
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </w-split>

    <evaluate-rules-add v-else></evaluate-rules-add>
</template>

<script>
import { mapState } from "vuex";
import evaluateRulesAdd from "./EvaluateRulesAdd";
import * as Api from "api/modules/evaluate-system/EvaluateRules.js";
export default {
    components: {
        evaluateRulesAdd,
    },
    data() {
        return {
            splitValue: 0.3,
            // 表格对象
            tableObj: {
                tableData: [],
                loading: false,
                border: true,
                resizable: true,
                size: "small",
                height: "100%",
            },
            // 弹窗对象
            dialogObj: {
                visible: false,
                width: "600px",
                title: "新增",
                type: "add",
                fullscreen: false,
                module: "",
            },
            // 左侧新增
            formData: {
                judgeRole: "",
                beJudgeRole: "",
                markObj: undefined,
                applyBus: undefined,
            },
            rules: {
                judgeRole: [
                    {
                        required: true,
                        message: "请选择考核人角色",
                        trigger: "change",
                    },
                ],
                beJudgeRole: [
                    {
                        required: true,
                        message: "请选择被考核人角色",
                        trigger: "change",
                    },
                ],
                markObj: [
                    {
                        required: true,
                        message: "请选择考核对象",
                        trigger: "change",
                    },
                ],
                applyBus: [
                    {
                        required: true,
                        message: "请选择适用业务",
                        trigger: "change",
                    },
                ],
            },
            // 是否显示右侧上面筛选条件
            showFilter: false,
            rightTableObj: {
                tableData: [],
                loading: false,
                border: true,
                resizable: true,
                size: "small",
                height: "100%",
            },
            // 右侧参数
            searchObj: {
                leftRowId: "",
                markObjName: "",
                judgeRoleName: "",
                beJudgeRoleName: "",
                currentPage: 1,
                pageSize: 10,
                totalResult: 0,
            },
        };
    },
    created() {
        // 如果是 返回的
        if (this.isBack) {
            if (this.$getSessionItem("evaluateAdd")) {
                this.searchObj = JSON.parse(this.$getSessionItem("evaluateAdd"));
                this.$removeSessionItem("evaluateAdd");
            }

            // 清除编辑时的缓存
            if (this.$getSessionItem("evaluateInfo")) {
                this.$removeSessionItem("evaluateInfo");
            }
        }

        // 初始查询
        this.doSearch();
    },
    methods: {
        // 左侧操作
        handleRolesClick(type, row) {
            switch (type) {
                case "delete":
                    this.$confirm("确认删除吗?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                        .then(() => {
                            Api.deleteRolesData({ id: row.id })
                                .then((res) => {
                                    if (res.operationCode === 1) {
                                        this.$message.success(res.msg);
                                    }
                                    // 刷新页面
                                    this.doSearch();
                                })
                                .catch((err) => {});
                        })
                        .catch(() => {});
                    break;
                default:
                    this.dialogObj.visible = true;
                    this.dialogObj.type = type;
                    this.dialogObj.module = "role";
                    type === "edit" ? this.$nextTick(() => {(this.formData = row)}) : "";
            }
        },

        // 左侧列表查询
        doSearch() {
            this.tableObj.loading = true;
            Api.getRolesData({})
                .then((res) => {
                    this.tableObj.loading = false;
                    if (res.operationCode === 1) {
                        this.tableObj.tableData = res.data;

                        if (res.data.length > 0) {
                            if (this.searchObj.leftRowId !== "") {
                                let _item = res.data.find(
                                    (x) => x.id === this.searchObj.leftRowId
                                );
                                this.$refs.leftTable.setCurrentRow(_item);
                                this.onLeftRowClick({ row: _item });
                            } else {
                                this.$refs.leftTable.setCurrentRow(res.data[0]);
                                this.onLeftRowClick({ row: res.data[0] });
                            }
                        }
                    }
                })
                .catch((err) => {
                    this.tableObj.loading = false;
                });
        },

        // 左侧行点击
        onLeftRowClick({ row, rowIndex, $rowIndex }) {
            // 渲染右侧列表
            this.searchObj.leftRowId = row.id;
            this.searchObj.beJudgeRoleName = row.beJudgeRoleName;
            this.searchObj.judgeRoleName = row.judgeRoleName;
            this.searchObj.markObjName = row.markObjName;
            this.searchObj.currentPage = 1;
            this.searchObj.pageSize = 10;

            this.getRightData();
        },

        // 左侧确认新增、编辑
        doRoleSave() {
            this.dialogObj.btnLoading = true;
            this.$refs.roleForm.validate((valid) => {
                if (valid) {
                    // console.log(this.formData);
                    let params = Object.assign({}, this.formData);
                    Api.saveRolesData(params)
                        .then((res) => {
                            this.dialogObj.btnLoading = false;
                            if (res.operationCode === 1) {
                                this.dialogObj.visible = false;
                                this.$message.success(res.msg);

                                this.doSearch();
                            }
                        })
                        .catch((err) => {
                            setTimeout(() => {
                                this.dialogObj.btnLoading = false;
                            }, 2000);
                        });
                } else {
                    setTimeout(() => {
                        this.dialogObj.btnLoading = false;
                    }, 2000);
                }
            });
        },

        // 左侧弹窗关闭前 清除数据
        onBeforeClose(done) {
            this.$refs.roleForm.resetFields()
            this.formData.id = ''
            done()
        },

        // *********************************
        // 右侧分页查询
        getRightData() {
            this.rightTableObj.loading = true;
            let params = {
                ruleId: this.searchObj.leftRowId, // 左侧规则表ID
                current: this.searchObj.currentPage, // 当前分页
                size: this.searchObj.pageSize, // 每页显示条数
            };
            Api.getRulesData(params)
                .then((res) => {
                    this.rightTableObj.loading = false;
                    if (res.operationCode === 1) {
                        this.rightTableObj.tableData = res.data.records;
                        this.searchObj.totalResult = parseInt(res.data.total);
                    }
                })
                .catch((err) => {
                    this.rightTableObj.loading = false;
                });
        },

        // 右侧操作
        handleTools(type, row) {
            let params = Object.assign({}, this.searchObj);

            switch (type) {
                case "delete":
                    this.$confirm("确认删除吗?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                        .then(() => {
                            Api.deleteRule({ id: row.id })
                                .then((res) => {
                                    if (res.operationCode === 1) {
                                        this.$message.success(res.msg);
                                    }
                                    // 刷新页面
                                    this.searchObj.currentPage = 1;
                                    this.searchObj.pageSize = 10;
                                    this.getRightData();
                                })
                                .catch((err) => {});
                        })
                        .catch(() => {});
                    break;
                default:
                    // 存值
                    this.$setSessionItem("evaluateAdd", JSON.stringify(params));

                    if (type !== "add") {
                        let rowObj = Object.assign({}, row);
                        // 存值
                        this.$setSessionItem("evaluateInfo", JSON.stringify(rowObj));
                    }

                    this.$router.push({
                        path: "/evaluate-rules",
                        query: {
                            type: type,
                            ruleId: this.searchObj.leftRowId,
                            markObjName: encodeURI(this.searchObj.markObjName),
                            judgeRoleName: encodeURI(this.searchObj.judgeRoleName),
                            beJudgeRoleName: encodeURI(this.searchObj.beJudgeRoleName),
                        },
                    });
            }
        },

        // 切换启用、禁用状态
        changeStatus(row) {
            let value = row.status === 1 ? 1 : 0;
            this.$confirm("确认切换该版本状态吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "info",
            })
                .then(() => {
                    Api.changeRuleState({ id: row.id, status: value })
                        .then((res) => {
                            if (res.operationCode === 1) {
                                this.$message.success(res.msg);
                            }
                            // 刷新页面
                            this.getRightData();
                        })
                        .catch((err) => {});
                })
                .catch(() => {
                    row.status = value === 1 ? 0 : 1;
                });
        },

        // 右侧分页切换
        handlePageChange({ currentPage, pageSize }) {
            this.searchObj.currentPage = currentPage;
            this.searchObj.pageSize = pageSize;
            this.getRightData();
        },

        // 刷新
        doRefresh() {
            this.searchObj.currentPage = 1;
            this.searchObj.pageSize = 10;
            this.getRightData();
        },
    },
    computed: {
        // 考核双方数组
        roleColumns() {
            let columns = [
                {
                    prop: "judgeRoleName",
                    title: "考核人角色",
                    minWidth: 120,
                    width: 0,
                    headerAlign: "center",
                    align: "center",
                    sortable: true
                },
                {
                    prop: "beJudgeRoleName",
                    title: "被考核人角色",
                    minWidth: 130,
                    width: 0,
                    headerAlign: "center",
                    align: "center",
                    sortable: true
                },
                {
                    prop: "markObjName",
                    title: "考核对象",
                    minWidth: 100,
                    width: 0,
                    headerAlign: "center",
                    align: "center",
                    sortable: true
                },
            ];
            return columns;
        },

        // 规则表头
        activeColumns() {
            let columns = [
                {
                    prop: "code",
                    title: "规则编号",
                    minWidth: 0,
                    width: 120,
                    headerAlign: "center",
                    align: "center",
                },
                {
                    prop: "sname",
                    title: "规则名称",
                    minWidth: 120,
                    width: 0,
                    headerAlign: "center",
                    align: "center",
                },
                {
                    prop: "value3",
                    title: "考核规则",
                    minWidth: 150,
                    width: 0,
                    headerAlign: "center",
                    align: "center",
                },
                {
                    prop: "version",
                    title: "版本",
                    minWidth: 0,
                    width: 100,
                    headerAlign: "center",
                    align: "center",
                },
                {
                    prop: "createUser",
                    title: "创建人",
                    minWidth: 0,
                    width: 100,
                    headerAlign: "center",
                    align: "center",
                },
                {
                    prop: "createDate",
                    title: "创建时间",
                    minWidth: 0,
                    width: 150,
                    headerAlign: "center",
                    align: "center",
                    // needRender: true,
                    // function: (val) => {
                    //     return val.slice(0, 10);
                    // },
                },
                {
                    prop: "remark",
                    title: "备注",
                    minWidth: 120,
                    width: 0,
                    headerAlign: "center",
                    align: "center",
                },
            ];
            return columns;
        },

        // 路由参数
        routeQuery() {
            return this.$route.query;
        },

        ...mapState("evaluate_dict", {
            pjdx: (state) => state.pjdx, // 考核对象数组
            pjrjs: (state) => state.pjrjs, // 考核人角色
            syyw: (state) => state.syyw, // 适用业务
        }),
        ...mapState("dict", {
            yyyw: (state) => state.yyyw,
        }),
        ...mapState("app", {
            isBack: (state) => state.isBack,
        }),
    },
};
</script>

<style scoped lang="less">
.detail-name {
    color: #2671CC;
    text-decoration: underline;
    cursor: pointer;
}
</style>
